import { actionTypes } from '../hooks/usePossibleActionTypes'

export const getActionTypeLabel = (value: string) => actionTypes.find((type) => type.value === value)?.label ?? ''
